import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/defaultOnJob`;

export type * from './viewModel';

export const ROUTE: RouteDefinition = `${baseRoute}/defaultOnJob`;

export const URL = (): RouteDefinition => `${baseRoute}/defaultOnJob`;
